import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

interface AuthRequiredDialogProps {
  open: boolean;
  onClose: () => void;
  onLogin: () => void;
}

function AuthRequiredDialog({ open, onClose, onLogin }: AuthRequiredDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Authentication Required</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          You need to be logged in to perform this action. Please log in to continue.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Cancel
        </Button>
        <Button
          onClick={onLogin}
          variant="contained"
          color="primary"
        >
          Log In
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AuthRequiredDialog;
